module.exports = __webpack_public_path__ + "static/media/dr-john-bennett-and-dan-pickett.c311b534.jpg";